<template>
  <div style="z-index: 999;background: rgba(0,0,0,0.5);">
    <div class="width-main">
      <div class="flexHeader">
        <div class="logo">
          <img style="width:110px;" @click="goHome()" :src="require('../../assets/logo.png')" />
        </div>
        <div class="menu">
          <template v-for="(item, index) in menuList">
            <div
              :key="index"
              @click="switchMenu(item, index)"
              :class="(item.hover ? 'match_hover ' : '') + ' menu-hover' + classController(index)"
            >
              {{ $t(item.title) }}
              <div class="program " v-if="item.hover">
                <div class="content">
                  <div class="event-cont" v-for="(it, ind) in eventList" :key="ind" @click.stop="goEvent(it, index)">
                    <a-avatar
                      :size="55"
                      :src="'https://static.daoba.com/sportsLogo/' + it.id + '.png'"
                      :style="{ backgroundColor: '#ffffff00' }"
                    >
                      <div style="width: 80px; height: 80px;border-radius: 50%;text-align: center;background: #ffffff;">
                        街
                      </div>
                    </a-avatar>
                    <div class="event-name">{{ it.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div>
          <div style="position: relative;top: 10px;">
            <LoginTag />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import LoginTag from '@comm/components/LoginTag.vue'
export default {
  name: 'headers',
  components: {
    LoginTag,
  },
  mounted() {},
  props: {
    type: {
      default: false,
    },
  },
  data() {
    return {
      activeMenu: store.getters['match/activeMenu'],
      menuList: [
        { title: '首页', path: '/', hover: false },
        { title: '赛事专区', path: '/Match', hover: false },
        { title: '活动专区', path: '/activity', hover: false },
        // { title: '场馆', path: '/stadium', hover: false },
        { title: '运动员榜', path: '/rank', hover: false },
        { title: '机构榜', path: '/agency', hover: false },
        { title: '赛事中心', path: '/matchCenter', hover: false },
        { title: '产品中心', path: '/productCenter', hover: true },
      ],
      eventList: [],
      hover: false,
    }
  },
  created() {
    this.getEvents()
    this.currentMenu()
  },
  methods: {
    goEvent(item, index) {
      this.activeMenu = index
      store.commit('match/MATCH_CHANGE_ACTIVE_MENU', index)
      // 将产品中心tab设置为默认第一个
      localStorage.setItem('project_centert_tab', 0)
      this.$router.push({
        path: '/productCenter',
        query: { programId: item.id, programName: item.name, programEnName: item.englishName },
      })
      // window.open('/Event?programId=' + item.id)
      // store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
      // this.$router.push({name: 'Event', query: {programId: item.id}})
    },
    currentMenu() {
      for (let index = 0; index < this.menuList.length; index++) {
        if (this.menuList[index].path == this.$route.fullPath) {
          this.activeMenu = index
        }
      }
    },
    getEvents() {
      this.$api.projectCenter.programs().then((res) => {
        if (res.status === 0) {
          this.eventList = res.data
        }
      })
    },
    switchMenu(item, index) {
      if (item.title != '产品中心') {
        this.activeMenu = index
        store.commit('match/MATCH_CHANGE_ACTIVE_MENU', index)
        this.$router.push(item.path)
      }
    },
    goHome() {
      this.activeMenu = 0
      store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 0)
      this.$router.push({
        name: 'Home',
      })
    },
    classController(index) {
      if (this.activeMenu === index) {
        return ' current'
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.user-img {
  width: 36px;
  border-radius: 50%;
}
.login-btn {
  width: 80px;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  color: #b01f23;
  background: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 3px 15px;
  outline: none;
}
.login-btn:hover {
  background: #ffd5d5;
}
.bgfff {
  background-color: rgb(184, 0, 0);
}
.flexHeader {
  display: flex;
  z-index: 20;
  position: relative;
  .logo {
    color: #fff;
    cursor: pointer;
  }
  .menu {
    width: 967px;
    margin-left: 40px;
    display: flex;
    justify-content: flex-start;
    div {
      margin: 0 10px;
      padding: 18px 20px;
      color: #fff;
      cursor: pointer;
      font-size: 0.9rem;
      border-bottom: 2px solid transparent;
      text-align: center;
    }
    .menu-hover:hover {
      border-bottom: 2px solid #b01f23;
    }
    .current {
      border-bottom: 2px solid #b01f23;
    }
  }
  .ant-dropdown-link {
    color: #fff;
  }
}
.width-main {
  width: 1200px;
  margin: 0 auto;
}
.bg {
  background-color: rgb(247, 247, 247);
}
.mr18 {
  margin-right: 18px;
}
.program {
  display: none;
  margin: 0;
  position: fixed;
  top: 60px;
  width: 100%;
  left: 0px;
  // background: red;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 3;
}
.match_hover:hover .program {
  // display:block;
  margin: 0;
  //   border-top: 1px solid #b01f23;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  padding: 0 150px;
}
// .event{
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;
//   // max-lines: 2;
//   justify-content: space-around;
//   align-items: center;
//   overflow: hidden;
// }
.content {
  width: 1200px;
  margin: 0 auto !important;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  overflow: hidden;
}
.event-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 12%;
  padding: 10px 20px;
  /*padding: 5px 0px;*/
  // background: yellow;
}
.event-cont:hover {
  transform: scale(1.2);
  .event-name {
    font-weight: bold;
  }
}
.event-img {
  width: 80px;
  height: 80px;
}
.event-name {
  color: #fff;
  font-size: 12px;
  padding: 9px 5px !important;
}
.font-css {
  width: 55px;
  height: 55px;
  font-weight: bold;
  line-height: 45px;
  border-radius: 50%;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/Header.vue